import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { OTHER_INTEGRATIONS } from 'services/consts';

const initialState = {
	smsProviders: [],
	connectedSmsProviders: [],
	loading: false,
	error: null
};

export const getSMSProviders = createAsyncThunk('integration/fetchSMSProviders', async (_, { getState }) => {
	const { smsProviders } = getState();
	if (smsProviders.smsProviders.length > 0) {
		return smsProviders.smsProviders;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(OTHER_INTEGRATIONS.GET_SMS_PROVIDERS);
	return response.data;
});

export const getConnectedSmsProviders = createAsyncThunk(
	'integration/getConnectedSmsProviders',
	async (payload, { getState }) => {
		const { smsProviders } = getState();
		if (smsProviders.connectedSmsProviders.length > 0 && payload?.invalidate !== true) {
			return smsProviders.connectedSmsProviders;
		}

		const axiosPrivate = useAxiosPrivate();
		const response = await axiosPrivate.post(OTHER_INTEGRATIONS.GET_CONNECTED_SMS_PROVIDERS);
		return response.data;
	}
);

const smsProviders = createSlice({
	name: 'smsProviders',
	initialState,
	reducers: {
		setConnectedSmsProviders: (state, { payload }) => ({
			...state,
			connectedSmsProviders: payload,
			loading: false
		})
	},
	extraReducers: (builder) => {
		builder.addCase(getSMSProviders.fulfilled, (state, { payload }) => {
			state.smsProviders = payload;
			state.loading = false;
		});
		builder.addCase(getSMSProviders.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(getSMSProviders.rejected, (state, { payload }) => {
			state.error = payload;
			state.loading = false;
		});
		builder.addCase(getConnectedSmsProviders.fulfilled, (state, { payload }) => {
			state.connectedSmsProviders = payload;
			state.loading = false;
		});
		builder.addCase(getConnectedSmsProviders.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(getConnectedSmsProviders.rejected, (state, { payload }) => {
			state.error = payload;
			state.loading = false;
		});
	}
});

export const { setConnectedSmsProviders } = smsProviders.actions;

export default smsProviders.reducer;
